import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import Styles from "./ViewBillList.module.css";
import cancelIcon from "../../../Assets/cross.png";
import Profile from "../../../Assets/user_img.png";
import mail from "../../../Assets/email.png";
import phone from "../../../Assets/mbl.png";
import location from "../../../Assets/location_img.png";
import {
  billPdfService,
  viewBillListService,
} from "../../../Services/ApiServices";
import Loader from "../../../SharedComponents/Loader/Loader";
import paymentType from "../../../Assets/payment_type.png";
import downloadIcon from "../../../Assets/download.png";
import moment from "moment";
import FileSaver from "file-saver";

export default function ViewBillList(props) {
  const [viewData, setViewData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [readmoreId, setReadmoreId] = useState([]);

  useEffect(() => {
    handleViewList();
  }, []);

  const handleViewList = () => {
    setIsLoader(true);
    viewBillListService(props.id)
      .then((res) => {
        setViewData(res.data);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast("Something went wrong!!", { type: "error" });
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleDownload = () => {
    setIsLoader(true);
    billPdfService(props.id)
      .then((res) => {
        let url = res.data.billing_url;
        let urlArr = url.split(".");
        let ext = urlArr[urlArr.length - 1];
        let dateTime =
          moment().format("DD-MM-YYYY") + "," + moment().format("hh:mm:ss a");
        let fileName = dateTime + "." + ext;
        FileSaver.saveAs(url, fileName);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong test!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleTotalAmount = (data) => {
    const total_amount = data.reduce(
      (prev, current) => prev + current?.total_price,
      0,
    );
    return total_amount + viewData?.delivery_charge;
  };

  return (
    <div>
      <Loader isLoader={isLoader} />
      <Modal show={props.isShow} onHide={props.onHide} centered size="lg">
        <Modal.Body>
          <div className={Styles.cancelImgParentContainer}>
            <div>
              <p className="fontBold">
                Bill <span className="orange">Details</span>
              </p>
            </div>
            <div className={Styles.iconsRow}>
              <div className={Styles.cancelImgContainer}>
                <img
                  style={{
                    display: props.isShowDownload ? null : "none",
                  }}
                  onClick={() => {
                    handleDownload();
                  }}
                  src={downloadIcon}
                  alt="Download"
                  className={Styles.cancelImg}
                />
              </div>
              <div className={Styles.cancelImgContainer}>
                <img
                  onClick={props.onHide}
                  src={cancelIcon}
                  alt="cancel"
                  className={Styles.cancelImg}
                />
              </div>
            </div>
          </div>
          <div>
            <div className={Styles.detailUserContainer}>
              <div className={Styles.userLeftContainer}>
                <img className={Styles.img} src={Profile} alt="profile" />
                <p className={Styles.username}>{viewData?.customer_name}</p>
              </div>
              <div className={Styles.userRightContainer}>
                <p className={Styles.username + " text-start"}>
                  Invoice No :
                  <span className={Styles.detail}>{viewData?.bill_no}</span>
                </p>
              </div>
            </div>
            <div className={Styles.detailContainer}>
              <img className={Styles.img} src={phone} alt="profile" />
              <p className={Styles.detail}>{viewData?.mobile_no}</p>
            </div>
            <div className={Styles.detailContainer}>
              <img className={Styles.img} src={mail} alt="profile" />
              <p className={Styles.detail}>
                {viewData?.email ? viewData?.email : "-"}
              </p>
            </div>
            <div className={Styles.detailContainer}>
              <img
                style={{ marginTop: "3px", alignSelf: "flex-start" }}
                className={Styles.location}
                src={location}
                alt="profile"
              />
              <p className={Styles.detail}>
                {viewData?.address}
                {","}
                <br />
                {viewData?.city_name}
                {","}
                <br />
                {viewData?.state_name}
                {viewData?.pincode ? (
                  <>
                    {" "}
                    {","}
                    <br />
                    {viewData?.pincode || ""}
                    {"."}
                  </>
                ) : (
                  "."
                )}
              </p>
            </div>
            <div className={Styles.detailUserContainer}>
              <div className={Styles.userLeftContainer}>
                <img className={Styles.img} src={paymentType} alt="profile" />
                <p className={Styles.username}>
                  {" "}
                  {viewData?.payment_type ? viewData?.payment_type : "-"}
                  <span style={{ fontWeight: 500 }}>
                    {viewData?.pos_number ? " - " + viewData?.pos_number : ""}
                  </span>
                </p>
              </div>
              <div className={Styles.userRightContainer}>
                <p className={Styles.username + " text-start"}>
                  Bill Status :
                  <span className={Styles.detail + " orange"}>
                    {viewData?.bill_status_type}
                  </span>
                </p>
              </div>
            </div>
          </div>
          {/* Purchased Products Table */}
          {viewData?.purchased_products?.length > 0 ? (
            <div className={Styles.tableParentContainer}>
              <div className={Styles.tableChildContainer + " mt-3"}>
                <table>
                  <thead>
                    <tr>
                      <th className=" label text-center">S.No</th>
                      <th className={Styles.productname + " label text-center"}>
                        Product Name
                      </th>
                      <th className={Styles.th + " label text-center"}>
                        Color
                      </th>
                      <th className={Styles.th + " label text-center"}>Unit</th>
                      <th className={Styles.th + " label text-center"}>Qty</th>
                      <th className=" label text-center">Price</th>
                      <th className=" label text-center">Total</th>
                    </tr>
                  </thead>
                  <tbody className={Styles.data}>
                    {viewData?.purchased_products?.map((e, index) => (
                      <tr key={e.customer_bill_id || e.product_id || index}>
                        <td className="text-center">{index + 1}</td>
                        <td
                          className={
                            Styles.productname + " contentFont text-center"
                          }
                        >
                          {readmoreId.includes(e.product_id)
                            ? e.product_name
                            : e.product_name?.substring(0, 37)}
                          {e.product_name?.length > 37 &&
                          !readmoreId.includes(e.product_id)
                            ? "..."
                            : null}
                          <span
                            style={{
                              display:
                                (e.product_name?.length || 0) < 37
                                  ? "none"
                                  : "block",
                            }}
                            className={Styles.readmore + " orange"}
                            onClick={() => {
                              if (readmoreId.includes(e.product_id)) {
                                let filterData = readmoreId.filter(
                                  (filterId) => filterId !== e.product_id,
                                );
                                setReadmoreId(filterData);
                              } else {
                                setReadmoreId([...readmoreId, e.product_id]);
                              }
                            }}
                          >
                            {readmoreId.includes(e.product_id)
                              ? "Show Less"
                              : "Read More"}
                          </span>
                        </td>
                        <td className={Styles.td}>{e?.color_name || "-"}</td>
                        <td className={Styles.td}>
                          {e?.product_unit?.unit_name ||
                            (typeof e?.product_unit === "string"
                              ? e?.product_unit
                              : "-")}
                        </td>
                        <td className={Styles.td}>{e?.quantity}</td>
                        <td className={Styles.td}>
                          {"₹ " +
                            (e?.price !== undefined && e?.price !== null
                              ? Number(e.price).toFixed(2)
                              : "0.00")}
                        </td>
                        <td className={Styles.td}>
                          {"₹ " +
                            (e?.total_price !== undefined &&
                            e?.total_price !== null
                              ? Number(e.total_price).toFixed(2)
                              : "0.00")}
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={5} />
                      <td className={Styles.td + " fw-bold"}>
                        Delivery Charge
                      </td>
                      <td className={Styles.td + " fw-bold"}>
                        {"₹ " +
                          (viewData?.delivery_charge !== undefined &&
                          viewData?.delivery_charge !== null
                            ? Number(viewData.delivery_charge).toFixed(2)
                            : "0.00")}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={5} />
                      <td className={Styles.td + " fw-bold"}>Total</td>
                      <td className={Styles.td + " fw-bold"}>
                        ₹{" "}
                        {handleTotalAmount(
                          viewData?.purchased_products,
                        )?.toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ) : null}

          {/* Additional Products Table (Separately Below Total) */}
          {(() => {
            let additionalProductsList = [];
            if (Array.isArray(viewData?.additional_products)) {
              additionalProductsList = viewData.additional_products;
            } else if (typeof viewData?.additional_products === "string") {
              try {
                const parsed = JSON.parse(viewData.additional_products);
                if (Array.isArray(parsed)) {
                  additionalProductsList = parsed;
                }
              } catch (e) {
                additionalProductsList = [];
              }
            }

            if (!additionalProductsList || additionalProductsList.length === 0) {
              return null;
            }

            return (
              <div className={Styles.tableParentContainer}>
                <p className="fontBold mt-3 mb-1">
                  Additional <span className="orange">Products</span>
                </p>
                <div className={Styles.tableChildContainer}>
                  <table>
                    <thead>
                      <tr>
                        <th className={Styles.th + " label text-center"}>
                          S.No
                        </th>
                        <th
                          className={Styles.productname + " label text-center"}
                        >
                          Product Name
                        </th>
                        <th className={Styles.th + " label text-center"}>
                          Brand
                        </th>
                        <th className={Styles.th + " label text-center"}>
                          Unit
                        </th>
                        <th className={Styles.th + " label text-center"}>
                          Qty
                        </th>
                      </tr>
                    </thead>

                    <tbody className={Styles.data}>
                      {additionalProductsList.map((e, index) => {
                        const manualKey = `manual_${index}_${e?.product_name}`;
                        const productName = e?.product_name || e?.name || "-";
                        const brandName = e?.brand_name || e?.brand || "-";
                        const unit =
                          e?.product_unit || e?.unit || e?.unit_name || "-";
                        const qty = Number(
                          e?.product_quantity ?? e?.quantity ?? e?.qty ?? 1,
                        );

                        return (
                          <tr key={manualKey}>
                            <td className="text-center">{index + 1}</td>
                            <td
                              className={
                                Styles.productname + " contentFont text-center"
                              }
                            >
                              {readmoreId.includes(manualKey)
                                ? productName
                                : productName.substring(0, 37)}
                              {productName.length > 37 &&
                                !readmoreId.includes(manualKey)
                                ? "..."
                                : null}

                              {productName.length > 37 && (
                                <span
                                  className={Styles.readmore + " orange"}
                                  onClick={() =>
                                    setReadmoreId((prev) =>
                                      prev.includes(manualKey)
                                        ? prev.filter((id) => id !== manualKey)
                                        : [...prev, manualKey],
                                    )
                                  }
                                >
                                  {readmoreId.includes(manualKey)
                                    ? "Show Less"
                                    : "Read More"}
                                </span>
                              )}
                            </td>
                            <td className={Styles.td}>{brandName}</td>
                            <td className={Styles.td}>{unit}</td>
                            <td className={Styles.td}>{qty}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })()}
        </Modal.Body>
      </Modal>
    </div>
  );
}
